import normalizePathname from '@/lib/routes/normalizePathname.js';
import { getAutomationsRouteContext, isAutomationsRoutePath } from '@/lib/automations/automationRoutes.js';
import resolveAutomationsPane from '@/lib/automations/resolveAutomationsPane.js';

const resolveMainThreadHeaderRouteContext = ({ activeAutomationsPane, pathname }) => {
  const normalizedPathname = normalizePathname(pathname);
  const isAutomationsView = isAutomationsRoutePath(normalizedPathname);
  const isConnectionsView = normalizedPathname === '/connections' || normalizedPathname.startsWith('/connections/');
  const isSkillsView = normalizedPathname === '/skills' || normalizedPathname.startsWith('/skills/');
  const isCanonicalAutomationsView = normalizedPathname === '/automations' || normalizedPathname.startsWith('/automations/');
  const automationsRouteContext = getAutomationsRouteContext(normalizedPathname);
  const resolvedAutomationsPane = resolveAutomationsPane({
    activeAutomationsPane,
    automationsRouteType: automationsRouteContext?.type || '',
    isCanonicalAutomationsView,
    isAutomationsView
  });
  const isAutomationsEditMode = Boolean(isCanonicalAutomationsView && automationsRouteContext?.type && automationsRouteContext?.id && automationsRouteContext?.isEdit);
  // The workflow thread hosted inside Automate is a thread screen like `/threads/:threadId`, so its
  // header carries the same thread actions; it is not a workflow edit view.
  const isAutomationsWorkflowThreadMode = Boolean(isCanonicalAutomationsView && automationsRouteContext?.type === 'workflows' && automationsRouteContext?.id && automationsRouteContext?.isConversation);
  const isSchedulesView = isAutomationsEditMode && resolvedAutomationsPane === 'schedules';
  const isTriggersView = isAutomationsEditMode && resolvedAutomationsPane === 'triggers';
  const isAutomationsWorkflowsView = isAutomationsEditMode && resolvedAutomationsPane === 'workflows';
  const isThreadlessRoute = isConnectionsView || isSkillsView || (isCanonicalAutomationsView && !isAutomationsEditMode && !isAutomationsWorkflowThreadMode);
  const isThreadScreenView = !isThreadlessRoute;

  return {
    automationsRouteContext,
    isAutomationsEditMode,
    isAutomationsWorkflowsView,
    isCanonicalAutomationsView,
    isConnectionsView,
    isSchedulesView,
    isSkillsView,
    isThreadScreenView,
    isThreadlessRoute,
    isTriggersView,
    normalizedPathname
  };
};

export default resolveMainThreadHeaderRouteContext;
